import React, {useState,useEffect, useContext}  from 'react'
import '../../../styles/devotionalHome.css'
import DevotionalSwiper from './devotionalSwiper'
import DevotionalHomeWeeklyCard from './devotionalWeeklyCardsContainer'
import DevotionalHomeBannerContainer from './devotionalHomeBanners'
import DevotionalHomeImageCard from './devotionalHomeImageCard'
import DevotionalHomeContentCardSection from './devotionalHomeContentCardSection'
import DevotionalInformationCards from './devotionalInformationCards'
// import VideoSection from './videoSection'
import { Helmet } from 'react-helmet-async'
import PageAds from '../../common/pageAds'
import { DeviceContext } from '..'





const weeklyCardData=[{url:"/devotional/assets/images/weekly/set1/lord-shiva1.png",link:"/weekly/lord-shiva-56.html"
},{url:"/devotional/assets/images/weekly/set1/Hanuman1.png",link:"/weekly/hanuman-57.html"},
  {url:"/devotional/assets/images/weekly/set1/Lord-Vinayaka1.png",link:"/weekly/vinayaka-84.html"},
  {url:"/devotional/assets/images/weekly/set1/Sai-Baba1.png",link:"/weekly/sai-baba-85.html"},{url:"/devotional/assets/images/weekly/set1/Durga-Devi1.png",link:"/weekly/durga-devi-86.html"},
  {url:"/devotional/assets/images/weekly/set1/Lakshmi-Devi1.png",link:"/weekly/lakshmi-devi-88.html"},{url:"/devotional/assets/images/weekly/set1/Lord-Venkateswara1.png",link:"/weekly/lord-venkateswara-121.html"},
]



  const bannerSectionItems=[
          [   
             {yurl:"https://www.youtube.com/c/ToneFashion",imgurl:"/devotional/assets/images/tone_fashion.webp"},
            {yurl:"https://www.youtube.com/c/HealthOne/videos",imgurl:"/devotional/assets/images/tone_health.webp"},
            {  yurl:"https://www.youtube.com/playlist?list=PLlk2ke0Me4Qlnox3NJ8upNzVnn-Is7Vjm",imgurl:"/devotional/assets/images/fun_bucket.webp"}
          ],
           [   
              {yurl:"https://www.onlinejyotish.com/",imgurl:"/devotional/assets/images/online_jyotish.webp"},
             {yurl:"https://www.youtube.com/channel/UCHtsA_T0_R9TW9oFI3I6qBA",imgurl:"/devotional/assets/images/tone_academy.webp"},
             {  yurl:"https://www.youtube.com/channel/UCjCHw0Np-xswtfxQac2yiYA",imgurl:"/devotional/assets/images/kidsone_telugu.webp"}
           ]
         
        ]


        const imageCardData= [{img_url:"/devotional/assets/images/Spiritual.webp",url:"https://spiritual.teluguone.com/"},
          {img_url:"/devotional/assets/images/Kalagnanam.webp",url:"/subpages/kalagnanam-55.html"},
          {img_url:"/devotional/assets/images/navodayam-banner.webp",url:"https://www.teluguone.com/devotional/navodayam/"},
          {img_url:"/devotional/assets/images/kartika-Maha-Puranam.webp",url:"/subpages/kartikamahapuranam-1045.html"},
          {img_url:"/devotional/assets/images/tirumalavaibhavam.webp",url:"https://www.teluguone.com/tirumalavaibhavam/indexHome.jsp"},
          {img_url:"/devotional/assets/images/ramayanm.webp",url:"https://www.teluguone.com/grandalayam/puranalu/ramayana/index.jsp"},
          {img_url:"/devotional/assets/images/mahabharatam.webp",url:"https://www.teluguone.com/grandalayam/puranalu/mahabharat/index.jsp"},
          {img_url:"/devotional/assets/images/Bhagavadgeetha.webp",url:"/subpages/bhagavadgeeta-680.html"},
          {img_url:"/devotional/assets/images/vedas.webp",url:"https://www.teluguone.com/grandalayam/puranalu/vedas/index.jsp"}
        ]
        


const DevotionalHome = ({data}) => {

        const initData= data?.[0]?.homeData || {}
        const d=initData || {}
        const {mobile,setMobile,containerRef} = useContext(DeviceContext)
    
      


    
              
      




      

  return (
   
           <div className='devotional-home'>
                 <Helmet > <title>Bhakti | Festivals | Bhakti Library | Bhakti Slokas | Vedas | Pravachanalu | Bhakti Songs | Bhakti Videos</title></Helmet>
               
               
                 <div className='container-fluid g-0'>

               <div className='row g-0'>
                   <div className='col-12'><DevotionalSwiper homeSliderData={d.homeSliderData} homeSliderDataError = {d.homeSliderDataError} /></div>
               </div>
                   {/*========================================================*/}
                   
                  <DevotionalInformationCards homeTithiData={d.homeTithiData} mmtImpDateData={d.mmtImpDateData}
                   homeTithiDataError = {d.homeTithiDataError} mmtImpDateDataError={d.mmtImpDateDataError}  />
                 {/*========================================================*/}
                <div className='row g-0'> 
                   <DevotionalHomeBannerContainer bannerSectionItems={bannerSectionItems[1]} />
                   </div>  
                 {/*========================================================*/}
                
                 <div className='row g-0'> 
                   
                    <div className='col-12'><h1 className='devotional-home-common-title weekly-row-title  d-sm-block'>Weekly Devotion</h1></div>
                 </div>
                {/*========================================================*/}

                <div className='weekly-row'  style={{border:"1px solid #e8ddd0",background:"#e8ddd0"}}> 
                
                  {weeklyCardData.map((item,index) => <DevotionalHomeWeeklyCard key={index} data={item} /> )}
                  <div className='col-10'></div>
                </div>
                {/*========================================================*/}
                
                <div className='row g-0'>     
                
                  <DevotionalHomeContentCardSection  contentCardsData={d.contentCardsData}  contentCardsDataError ={d.contentCardsDataError} />
                  </div> 
                {/*========================================================*/}
                <div className='row g-0'>
                   <DevotionalHomeBannerContainer bannerSectionItems={bannerSectionItems[0]} />
                </div>
                {/*========================================================*/}
                <div className='row g-0 d-md-flex d-none'>
               
                <div className='col-12'></div>
                    {imageCardData.map((item,index) => <DevotionalHomeImageCard key={index} imageCard={item} />)}
               </div>
                {/*========================================================*/}

                 </div>         
               <PageAds  mobile={mobile} containerRef={containerRef} />
               </div>
               
   
  )
}

export default DevotionalHome;
